import NewsInfo from "../NewsInfo";
import img1 from "../../../assets/images/index/news/用心守護每一程.jpg";

const News5 = () => {
  const title = "用心守護每一程";
  const date = "May. 22,2025";
  const content = `司機輕托住安全帶，等扣環穩穩地卡上，才慢慢放開手。整個動作沒有多餘聲音，卻讓人感受到細心。不是急著完成任務，而是默默守護每一段上車的開始。就像風平浪靜的日子裡，有人默默為你撐著傘。上車的那一刻，你不只是乘客，而是被用心照顧的旅人。💕`;

  return NewsInfo(title, date, content, img1);
};

export default News5;
